import { render, staticRenderFns } from "./refComponentsTable.vue?vue&type=template&id=b155db92"
import script from "./refComponentsTable.vue?vue&type=script&lang=js"
export * from "./refComponentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports